<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_40 col_20'><span class='brt high default' id='text1'>NATIONAL RAILROAD  PASSENGER CORPORATION</span>  </div>
  <div class='lgr_05 col_75'><span class='default' id='text2'>S145G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><dynamic-field [id]='"scrntm"' [size]=8 [line]=2 [column]=1 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_34 col_23'><span class='brt high default' id='text3'>NEWJERSEY TRANSIT - FLASH A SYSTEM</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_33 col_24'><span class='brt high default' id='text4'>MONTHLY SURVEY MAINTENANCE SCREEN</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_40 col_20'><span class='brt high default' id='text5'>----------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text6'>ENTER REQUIRED FIELDS AND HIT APPROPRIATE FUNCTION KEY:</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text7'>-------------------------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><span class='default' id='text8'>TRN-NBR:</span>  </div>
  <div class='lgr_04 col_12'><dynamic-field [id]='"trnnbr"' [size]=4 [line]=9 [column]=12 [(ngModel)]='trnnbr'></dynamic-field></div>
  <div class='lgr_01 col_17'><span class='default' id='text9'>-</span>  </div>
  <div class='lgr_02 col_19'><dynamic-field [id]='"legnbr"' [size]=2 [line]=9 [column]=19 [(ngModel)]='legnbr'></dynamic-field></div>
  <div class='lgr_00 col_22'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_13 col_01'><span class='default' id='text11'>NO-OF-RIDERS:</span>  </div>
  <div class='lgr_04 col_15'><dynamic-field [id]='"riders1"' [size]=4 [line]=11 [column]=15 [(ngModel)]='riders1'></dynamic-field></div>
  <div class='lgr_00 col_20'>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_24 col_01'><span class='default' id='text13'>(JUNE 15TH TO LABOR DAY)</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_13 col_01'><span class='default' id='text14'>NO-OF-RIDERS:</span>  </div>
  <div class='lgr_04 col_15'><dynamic-field [id]='"riders2"' [size]=4 [line]=14 [column]=15 [(ngModel)]='riders2'></dynamic-field></div>
  <div class='lgr_00 col_20'>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_34 col_01'><span class='default' id='text16'>(DAY AFTER LABOR DAY TO JUNE 14TH)</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><span class='default' id='text17'>PF3=EXIT</span>  </div>
  <div class='lgr_10 col_11'><span class='default' id='text18'>PF4=RETURN</span>  </div>
  <div class='lgr_07 col_23'><span class='default' id='text19'>PF5=ADD</span>  </div>
  <div class='lgr_10 col_32'><span class='default' id='text20'>PF6=UPDATE</span>  </div>
  <div class='lgr_10 col_44'><span class='default' id='text21'>PF9=DELETE</span>  </div>
  <div class='lgr_12 col_56'><span class='default' id='text22'>ENTER=SELECT</span>  </div>
  <div class='lgr_09 col_70'><span class='default' id='text23'>PF12-LIST</span>  </div>
</div>
</div>
